
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';
import { Menu, Info, Sparkles } from 'lucide-react';
import { APP_ICON_PATH, APP_NAME } from '@/config/branding';
import { IS_DEMO } from '@/core/environment';

const FLOWERS = ['🌸', '🌺', '✿', '❀', '🌷', '💮'];

const Layout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex h-screen overflow-hidden bg-gradient-to-br from-pink-50 via-rose-50/40 to-fuchsia-50/30 flex-col relative">
            {/* Floating flower decorations */}
            <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
                {FLOWERS.map((f, i) => (
                    <span
                        key={i}
                        className="flower-deco"
                        style={{
                            left: `${10 + i * 15}%`,
                            top: `${15 + (i % 3) * 25}%`,
                            animationDelay: `${i * 1.2}s`,
                            animationDuration: `${5 + i * 0.8}s`,
                            fontSize: `${0.8 + (i % 3) * 0.4}rem`,
                        }}
                    >
                        {f}
                    </span>
                ))}
            </div>

            {IS_DEMO && (
                <div className="bg-gradient-to-r from-pink-500 via-rose-500 to-fuchsia-500 text-white px-4 py-2 flex items-center justify-between text-xs font-medium z-50">
                    <div className="flex items-center gap-2">
                        <Sparkles size={14} />
                        <span>MODO DEMO — Los datos son de ejemplo y no se guardarán permanentemente</span>
                    </div>
                    <div className="flex items-center gap-4">
                        <a href="/glowpro/download/" className="underline hover:text-pink-100">Descargar App Nativa</a>
                    </div>
                </div>
            )}
            <div className="flex flex-1 overflow-hidden relative z-10">
                {/* Sidebar Component */}
                <Sidebar
                    isOpen={sidebarOpen}
                    toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
                />

                {/* Mobile Header */}
                <div className="fixed top-0 left-0 right-0 h-16 bg-white/80 backdrop-blur-xl border-b border-pink-100 flex items-center px-4 md:hidden z-30">
                    <button onClick={() => setSidebarOpen(true)} className="p-2 text-pink-400">
                        <Menu size={24} />
                    </button>
                    <div className="ml-4 flex items-center gap-3 min-w-0">
                        <img src={APP_ICON_PATH} alt="" className="w-9 h-9 rounded-xl border border-pink-200 bg-white p-1.5 flex-shrink-0" />
                        <span className="font-bold text-lg text-shimmer truncate">{APP_NAME}</span>
                    </div>
                </div>

                {/* Main Content Area */}
                <main className="flex-1 overflow-y-auto overflow-x-hidden md:ml-64 pt-16 md:pt-0">
                    <div className="container mx-auto px-4 py-8 md:px-8">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Layout;
